module.exports = __webpack_public_path__ + "14003b8f65edf837f9f248d575870b52.jpg";